export default __webpack_public_path__ + "static/media/frango-screenshot-04.c34566a3.png";